<template>
  <div class="text-xs-center">
    <v-dialog v-model="showErrorDialog" max-width="400" transition="scale-transition">
      <v-card>
        <v-card-text class="pa-4">
          <v-alert
            :value="true"
            type="warning"
            class="text-xs-left black--text strong"
          >
            {{ message }}
          </v-alert>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="warning" @click="callHide">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ErrorDialog",
  props: {
    message: String,
    show: Boolean,
    timeout: Number,
    callHide: Function
  },
  computed: {
    showErrorDialog: {
      get() {
        return this.show;
      },
      set() {
        // don't set from here
      }
    }
  }
};
</script>
